"use client";

import { ArrowRight } from "lucide-react";
import * as React from "react";

import { CarouselButton } from "@/components/carousel/CarouselButton";
import { useCarousel } from "@/components/carousel/useCarousel";
import { cn } from "@/utils/cn";

export const CarouselNext = React.forwardRef<
  HTMLButtonElement,
  React.ComponentProps<typeof CarouselButton>
>(({ className, variant = "outline", size = "icon", ...props }, ref) => {
  const { orientation, scrollNext, canScrollNext } = useCarousel();

  return (
    <CarouselButton
      ref={ref}
      variant={variant}
      size={size}
      className={cn(
        "absolute h-8 w-8 rounded-full",
        orientation === "horizontal" ?
          "-right-12 top-1/2 -translate-y-1/2"
        : "-bottom-12 left-1/2 -translate-x-1/2 rotate-90",
        className
      )}
      disabled={!canScrollNext}
      onClick={scrollNext}
      {...props}
    >
      <ArrowRight className="h-4 w-4" />
      <span className="sr-only">Next slide</span>
    </CarouselButton>
  );
});
CarouselNext.displayName = "CarouselNext";
